import { Api } from '../../Api';
import { ISettingsClearingParams } from '@shared/api/ServiceAPI/Clearing/params';
import { IServiceKycResponse, ISettingsAccountsDto } from '@shared/api';

export class Clearing {
    private static _basePath = '/Clearing';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Clearing._basePath}`;
        return {
            async accountApprove({ id, comment }: ISettingsClearingParams) {
                const path = `/account/approve`;
                return await Api.post<ISettingsAccountsDto>({
                    path: `${basePath}${path}`,
                    body: { accountId: id, comment },
                });
            },
            async accountReject({ id, comment }: ISettingsClearingParams) {
                const path = `/account/reject`;
                return await Api.post<ISettingsAccountsDto>({
                    path: `${basePath}${path}`,
                    body: { accountId: id, comment },
                });
            },
            async accountVerify({ id }: ISettingsClearingParams) {
                const path = `/account/verify/${id}`;
                return await Api.post<IServiceKycResponse>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
